import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpInterceptorProviders } from './interceptors';
import { NavbarComponent } from './navbar/navbar.component';
import {
  CaregiverManagementDashboardModule
} from './caregiver-management-dashboard/caregiver-management-dashboard.module';
import { TeamEngageDashboardModule } from './team-engage-dashboard/team-engage-dashboard.module';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppComponent,
    NavbarComponent,
    CaregiverManagementDashboardModule,
    TeamEngageDashboardModule
  ],
  providers: [HttpInterceptorProviders],
  bootstrap: [AppComponent],
})
export class AppModule {
}
